import { ExclamationCircleOutlined } from '@ant-design/icons';
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

const CssTextField = withStyles({
	root: {
		"& label.Mui-focused": {
			borderWidth: 1,
			color: "#242424",
			fontSize: "12px !important",
			fontWeight: "300 !important", //regular
			lineHeight: "12px !important",
		},
		"& .MuiOutlinedInput-input": {
			fontSize: "14px !important",
		},
		"& .MuiInput-underline:after": {
			borderBottomColor: "#646BDB",
		},
		"& .MuiFormLabel-root": {
			fontSize: "12px !important",
			fontWeight: "300 !important",
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				borderColor: "#D6D6D6",
				borderWidth: 1,
			},
			"&:hover fieldset": {
				borderColor: "#929090",
				color: "#929090",
			},
			"&.Mui-focused fieldset": {
				borderColor: "#646BDB",
			},
		},
		"& .MuiOutlinedInput-notchedOutline": {
			"& legend": {
				borderBottom: "none !important",
			},
		},
		"& .MuiFormHelperText-root": {
			"& .error-text": {
				fontSize: 10,
			},
		},
	},
})(TextField);

const useStyles = makeStyles(() => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
}));

/**
 * 
 * @param {import("@material-ui/core").TextFieldProps} props 
 * @returns 
 */
export default function CustomInput(props) {
	const classes = useStyles();

	return (
        <div className={classes.root}>
			<CssTextField
				disabled={props.disabled}
				style={props.style}
				multiline={props.multiline || false}
				required={props.required}
				label={`${props.label}${props.tick ? "" : "*"}`}
				inputProps={{ maxLength: props.maxLength || undefined }}
				helperText={
					props.twitter
						? `${280 - props.twitterLength}`
						: props.helperTextValue
						  ? `${props.value.length}/${props.maxLength || 1000}`
						  : false
				}
				fullWidth
				variant="outlined"
				id="custom-css-outlined-input"
				value={props.value}
				onChange={(val) => props.onInput(val)}
			/>
			{props.required ? (
				<FormHelperText>
					<div className="error-text">
						<ExclamationCircleOutlined className="error-text-icon" />
						please enter {props.label.toLowerCase()}
					</div>
				</FormHelperText>
			) : null}
		</div>
    );
}

CustomInput.defaultProps = {
	style: {},
};
